module.exports = __webpack_public_path__ + "/login_ui/img/lr-f1dab847bd196099e17a36724f98da94.svg";